var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("button", [
        _c("img", {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle.vertical-menu",
              modifiers: { "vertical-menu": true }
            }
          ],
          staticClass: "rounded-btn",
          attrs: {
            src: "/static-appopensalud/img/icons/hamburguer-menu-icon-blue.svg",
            id: "menu-icon"
          }
        })
      ]),
      _vm._v(" "),
      _c("b-sidebar", {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.onOutsideSidebarClickConfig,
            expression: "onOutsideSidebarClickConfig"
          }
        ],
        attrs: {
          id: "vertical-menu",
          width: _vm.menu.activeNavItem
            ? _vm.sidebarOpenedWidth
            : _vm.sidebarClosedWidth,
          "no-header": "",
          shadow: ""
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var hide = ref.hide
              return [
                _c(
                  "div",
                  { staticClass: "row", attrs: { id: "sidebar-header" } },
                  [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _vm.menu.activeNavItem
                          ? _c("b-icon-chevron-left", {
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  return _vm.$store.commit(
                                    "video/setMenuActiveNavItem",
                                    null
                                  )
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("b-icon-x", {
                          staticClass: "float-right",
                          staticStyle: { cursor: "pointer" },
                          on: { click: hide }
                        })
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                !_vm.menu.activeNavItem
                  ? _c(
                      "b-nav",
                      { attrs: { vertical: "" } },
                      [
                        _vm.$store.getters["session/userIsProfessional"]
                          ? _c(
                              "b-nav-item",
                              {
                                attrs: {
                                  "data-nav-item": "appointment-info",
                                  active:
                                    _vm.menu.activeNavItem == "appointment-info"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$store.commit(
                                      "video/setMenuActiveNavItem",
                                      "appointment-info"
                                    )
                                  }
                                }
                              },
                              [
                                _c("base-icon", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src:
                                      "/static-appopensalud/img/icons/morillas-svg-icons/primary/doc-icon-blue.svg"
                                  }
                                }),
                                _vm._v(
                                  _vm._s(_vm.$t("menu.appointment-info")) +
                                    "\n          "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$store.getters["session/userIsProfessional"]
                          ? _c(
                              "b-nav-item",
                              {
                                attrs: {
                                  "data-nav-item": "notes",
                                  active: _vm.$store.commit(
                                    "video/setMenuActiveNavItem",
                                    "notes"
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$store.commit(
                                      "video/setMenuActiveNavItem",
                                      "notes"
                                    )
                                  }
                                }
                              },
                              [
                                _c("base-icon", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    src:
                                      "/static-appopensalud/img/icons/morillas-svg-icons/primary/pencil-icon-blue.svg"
                                  }
                                }),
                                _vm._v(
                                  _vm._s(_vm.$t("menu.notes")) + "\n        "
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "b-nav-item",
                          {
                            attrs: {
                              "data-nav-item": "docs",
                              active: _vm.menu.activeNavItem == "docs"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  "video/setMenuActiveNavItem",
                                  "docs"
                                )
                              }
                            }
                          },
                          [
                            _c("base-icon", {
                              staticClass: "mr-2",
                              attrs: {
                                src:
                                  "/static-appopensalud/img/icons/morillas-svg-icons/primary/clinic-doc-icon-blue.svg"
                              }
                            }),
                            _vm._v(
                              _vm._s(_vm.$t("menu.clinical_documents")) +
                                "\n        "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.$uiHelpers.isMobile
                          ? _c("div", [
                              _c("hr", { staticStyle: { color: "gray" } }),
                              _vm._v(" "),
                              _c("li", { staticClass: "nav-item" }, [
                                _c("span", { staticClass: "nav-link" }, [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.$t("menu.devices")))
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "nav-item nav-link" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    [
                                      _c("base-icon", {
                                        staticClass: "mb-2 mr-2",
                                        attrs: {
                                          src:
                                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/camera-icon-blue.svg"
                                        }
                                      }),
                                      _vm._v(" " + _vm._s(_vm.$t("camera")))
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("base-select", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      id: "video-device-selector",
                                      insideDiv: "",
                                      label: "label",
                                      options: _vm.videoDevices,
                                      valueProp: "deviceId"
                                    },
                                    model: {
                                      value: _vm.selectedVideoSource,
                                      callback: function($$v) {
                                        _vm.selectedVideoSource = $$v
                                      },
                                      expression: "selectedVideoSource"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                { staticClass: "nav-item nav-link" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "mb-2" },
                                    [
                                      _c("base-icon", {
                                        staticClass: "mb-2 mr-2",
                                        attrs: {
                                          src:
                                            "/static-appopensalud/img/icons/morillas-svg-icons/primary/mic-icon-blue.svg"
                                        }
                                      }),
                                      _vm._v(
                                        "  " + _vm._s(_vm.$t("microphone"))
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("base-select", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      id: "audio-device-selector",
                                      value: _vm.selectedAudioSource,
                                      insideDiv: "",
                                      label: "label",
                                      options: _vm.audioDevices,
                                      valueProp: "deviceId"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.$store.getters["session/userIsProfessional"]
                                ? _c("div", [
                                    _c("li", { staticClass: "nav-item" }, [
                                      _c(
                                        "span",
                                        { staticClass: "nav-link" },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: { switch: "" },
                                              model: {
                                                value: _vm._useStethoscope,
                                                callback: function($$v) {
                                                  _vm._useStethoscope = $$v
                                                },
                                                expression: "_useStethoscope"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "nav-item-icon",
                                                attrs: {
                                                  src:
                                                    "/static-appopensalud/img/icons/stethoscope-gray.svg"
                                                }
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("enable-stethoscope")
                                                ) + "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("li", { staticClass: "nav-item" }, [
                                      _c(
                                        "span",
                                        { staticClass: "nav-link" },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: { switch: "" },
                                              model: {
                                                value: _vm._useLamp,
                                                callback: function($$v) {
                                                  _vm._useLamp = $$v
                                                },
                                                expression: "_useLamp"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "nav-item-icon",
                                                attrs: {
                                                  src:
                                                    "/static-appopensalud/img/icons/lamp-gray.svg"
                                                }
                                              }),
                                              _vm._v(
                                                _vm._s(_vm.$t("enable-lamp")) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _vm.$uiHelpers.isMobile && _vm.videoDevices.length > 1
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "span",
                                  { staticClass: "nav-link" },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: { switch: "" },
                                        on: { change: _vm.toggleMobileCamera },
                                        model: {
                                          value: _vm.useRearCamera,
                                          callback: function($$v) {
                                            _vm.useRearCamera = $$v
                                          },
                                          expression: "useRearCamera"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "nav-item-icon",
                                          attrs: {
                                            src:
                                              "/static-appopensalud/img/icons/swap_camera_mobile.svg"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.useFrontCamera
                                                ? _vm.$t(
                                                    "swap-cameras-mobile-rear"
                                                  )
                                                : _vm.$t(
                                                    "swap-cameras-mobile-front"
                                                  )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.menu.activeNavItem,
                        expression: "menu.activeNavItem"
                      }
                    ]
                  },
                  [
                    _c("loading-anim", {
                      attrs: { active: _vm.$store.state.loading }
                    }),
                    _vm._v(" "),
                    _vm.menu.activeNavItem == "appointment-info"
                      ? _c("appointment-info")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.menu.activeNavItem == "notes"
                      ? _c("appointment-notes")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.menu.activeNavItem == "docs"
                      ? _c("documents-table")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.menu.activeNavItem == "history"
                      ? _c("clinic-history")
                      : _vm._e(),
                    _vm._v(" "),
                    _c("help-section", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.menu.activeNavItem == "support-chat",
                          expression: "menu.activeNavItem == 'support-chat'"
                        }
                      ]
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { id: "sidebar-footer" } },
                      [
                        _c(
                          "b-nav-item",
                          {
                            attrs: {
                              "data-nav-item": "support-chat",
                              active: _vm.menu.activeNavItem == "support-chat"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$store.commit(
                                  "video/setMenuActiveNavItem",
                                  "support-chat"
                                )
                              }
                            }
                          },
                          [
                            _c("support-chat-button", [
                              _vm._v(_vm._s(_vm.$t("need-help")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("stethoscope-modal", { ref: "stethoscopeModal" }),
                _vm._v(" "),
                _c("lamp-modal", { ref: "lampModal" })
              ]
            }
          }
        ]),
        model: {
          value: _vm.sidebarVisible,
          callback: function($$v) {
            _vm.sidebarVisible = $$v
          },
          expression: "sidebarVisible"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30b0e3de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30b0e3de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/VideoSidebar.vue
// module id = 3697
// module chunks = 31